import React,{useState, useEffect}  from 'react';

import Sides from '../Bars/Jssidebar';
import Button from 'react-bootstrap/Button'
import {Helmet} from "react-helmet";
function Cscomment(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
      <Sides/>

<Helmet>
 
 <title>Learn Free JavaScript Comments Tutorials For Beginners CodeExampler</title>
 <meta name="description" content="Javascript comments tutorial for beginners Comments in Javascript are only for you to read.If you type any type of contents inside Javascript comments are ignored by the compiler. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,tutorial for begineers,Javascript comments,javascript comment,javascript comment block,javascript comment multiple lines,javascript comment line" />
 <link rel="canonical" href="https://www.codeexampler.com/javascript-comment" />
 </Helmet>

 <div className='lg:pl-56'>

<h1 className="m-4 mh1">Types Of Comment in Javascript </h1>
<div className="first">
        <a href="/javascript-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <p className="mt-4 para">1, Comments in Javascript are used only for you to read.
<br/>2, If you type any content inside Javascript, comments are ignored by the compiler
</p>


<h2 className="headings">Javascript Comments Example: </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-10">{`/*`} </span>
          <span className="qwerty-3">hello </span>
          <span className="qwerty-3">ram </span>
          {"\n"}
          <span className="qwerty-3">Hello, </span>
          <span className="qwerty-3">Bharat </span>
          <span className="qwerty-10">{`*/`}</span>

          {"\n"}  {"\n"}
        </code>
      </pre>
    </div>

<h2 className=" mt-4 mh2 bold"> There are two types of comments in a Javascript programming language.</h2>
<h3 className="mt-3  mh3 bold">1, Single-line comment<br/>
2, Multi-line comment<br/>
</h3>

<h2 className="mt-3">1, Single-line Comment:</h2>

<p className="mt-4 para">This single-line comment starts with a &#47;&#47; tag and ends at the end of the line.
</p>


<h2 className="headings">Single-Line Comments in Javascript Example: </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-10">{`//`} </span>
          <span className="qwerty-3">My name is CodeExampler.com </span>
          {"\n"}
          <span className="qwerty-10">{`//`} </span>
          <span className="qwerty-3">This is a Js programming</span>

          {"\n"}  {"\n"}
        </code>
      </pre>
    </div>

    <h2 className="mt-3">2, Multi-line Comment:</h2>

<p className="mt-4 para">That is a multi-line comment in Javascript and This type of comment must begin with /* and end with */. if you write anything inside this comment, symbols ignore by the compiler</p>






<h2 className="headings">Multi-line Comments in Javascript Example: </h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-10">{`/*`} </span>
          <span className="qwerty-3">My name is CodeExampler.com </span>
          {"\n"}
          <span className="qwerty-3">That is a Javascript programming </span>
          <span className="qwerty-10">{`*/`}</span>

          {"\n"}  {"\n"}
        </code>
      </pre>
    </div>


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/javascript-keyword">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/javascript-identifier">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>

        </div>
    </div>
)

}
export default Cscomment;